import React from 'react'
import { Navigate } from 'react-router-dom'
import { AgTechWebApplication } from '../../../application/AgTechWebApplication';

const AgTechWebAppLanding = (props: { app: AgTechWebApplication }) => {
    return props.app.structure.landingPage ?
        props.app.structure.landingPage(props.app) :
        <Navigate to='/app/home' />;
}

export default AgTechWebAppLanding